import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";
import { z } from "zod";

export const repoSchema = z.object({
  name: requiredString().min(1, REQUIRED_MESSAGE),
});
